export const BASE_URL = "https://url1short.herokuapp.com/"
export const NETLIFY_URL = "https://urlshort.netlify.com/"
export const GET_SHORT_URL = "GetShortUrl"
export const GET_FULL_URL = "GetFullUrl"
